import { MDBIcon } from 'mdb-react-ui-kit';
import React, { useContext } from 'react';
import useResumeBusinessSkillsHandlers from "../../../context/resume/hooks/resume-business-skills-handlers";
import { TranslationContext } from "../../../context/translations/translations-context";
import { useCurrentUserRoles } from "../../../hooks/useCurrentUserRoles";
import useResumeDocumentSection from "../../../hooks/useResumeDocumentSection";
import useResumeProperties from "../../../hooks/useResumeProperties";
import StarRating from '../../assets/StarRating';


export default function BusinessSkillsPreview() {

    const { translations } = useContext(TranslationContext);
    const { businessSkills } = useResumeDocumentSection();
    const { handleRemoveCompetence, handleChangeCompetence } = useResumeBusinessSkillsHandlers('businessSkills');
    const { isAlcyone, isEuropass, documentLanguage } = useResumeProperties();
    const { isManagerRole } = useCurrentUserRoles();

    return (
        <>
            <div style={ { marginTop: "-12px" } }>
                <div
                    className={ isEuropass ? "row no-page-break" : "col" }
                    style={ { overflowX: 'auto' } }
                >
                    { businessSkills
                        ?.sort( ( a, b ) => a.order - b.order )
                        .map( ( businessSkill, categoryIndex ) => (
                            <React.Fragment key={ categoryIndex }>
                                <div className="col-sm-12 col-md-2 col-lg-2">
                                    { isEuropass ? (
                                        <p className="p-0 m-0"
                                           style={ { color: "#000000", fontSize: "11px", width: "205px" } }>
                                            <strong>{ businessSkill.category?.translations?.[ documentLanguage ] }</strong>
                                        </p>
                                    ) : (
                                        <p className="p-0 m-0" style={ {
                                            color: isAlcyone ? "#09B4BF" : "#0B86C8",
                                            fontSize: "11px",
                                            width: "115%"
                                        } }>
                                            { businessSkill.category?.translations?.[ documentLanguage ] }
                                        </p>
                                    ) }
                                </div>
                                <div className="col-sm-12 col-md-10 col-lg-10">
                                    <div
                                        className="d-flex flex-md-wrap flex-lg-wrap flex-sm-nowrap gap-2"
                                        style={ { maxWidth: "100%", fontSize: "11px" } }
                                    >
                                        { businessSkill.competences
                                            .map( ( competence, competenceIndex ) =>
                                                (
                                                    <div key={ competenceIndex }
                                                         className={ isEuropass ? ""
                                                             : "gap-1 d-md-flex d-lg-flex" }
                                                         style={ {
                                                             width: isEuropass ? ""
                                                                 : "calc(50% - 1rem)",
                                                             alignItems: "center",
                                                             boxSizing: "border-box",
                                                         } }>
                                                        { isManagerRole && (
                                                            <MDBIcon
                                                                far
                                                                icon="trash-alt"
                                                                style={ {
                                                                    color: isAlcyone ? "#09B4BF"
                                                                        : "#0B86C8",
                                                                    fontSize: "11px",
                                                                    marginRight: "8px",
                                                                    cursor: "pointer",
                                                                    fontWeight: 'bold'
                                                                } }
                                                                onClick={ () =>  window.confirm(translations.general.confirmationMessage) && handleRemoveCompetence( competence, businessSkill.order ) }
                                                                role="button"
                                                                size="lg"
                                                            />
                                                        ) }
                                                        <span className="text-black"
                                                              style={ {
                                                                  width: "40%",
                                                                  alignItems: "center",
                                                                  fontSize: "11px",
                                                              } }>
                                                                            { competence?.translations?.[ documentLanguage ] }
                                                                        </span>
                                                                { competence?.translations?.[ documentLanguage ] && (
                                                            <div
                                                                className="d-md-flex d-lg-flex align-items-center">
                                                                { !isEuropass && (
                                                                    <div style={ {
                                                                        marginTop: "-4px",
                                                                        width: "60px"
                                                                    } }>
                                                                        <StarRating
                                                                            rating={ competence.level || 0 }
                                                                            onChange={ (rating) => {
                                                                                const fallbackId =
                                                                                    Number.isInteger(businessSkill?.order) && Number.isInteger(competence?.order)
                                                                                        ? businessSkill.order * 1000 + competence.order + 1
                                                                                        : null;
                                                                                handleChangeCompetence(
                                                                                    {
                                                                                        ...competence,
                                                                                        id: competence?.id ?? fallbackId,
                                                                                        level: rating
                                                                                    },
                                                                                    businessSkill.order
                                                                                );
                                                                            } }
                                                                        />
                                                                    </div>
                                                                ) }
                                                                {/*TODO calculate the duration for each competences*/}
                                                                {/*{competenceDurations[ competence.competenceName ] &&*/ }
                                                                {/*    !isEuropass && (*/ }
                                                                {/*        <div style={{*/ }
                                                                {/*            fontSize: "9px",*/ }
                                                                {/*            width: "40px"*/ }
                                                                {/*        }}>*/ }
                                                                {/*            {`${competenceDurations[ competence.competenceName ].years > 0*/ }
                                                                {/*                ? `${competenceDurations[ competence.competenceName ].years} ${translations.years} `*/ }
                                                                {/*                : ''*/ }
                                                                {/*            }*/ }
                                                                {/*${competenceDurations[ competence.competenceName ].months > 0*/ }
                                                                {/*  ? `${competenceDurations[ competence.competenceName ].months} ${translations.months}`*/ }
                                                                {/*  : ''*/ }
                                                                {/*            }`}*/ }
                                                                {/*        </div>*/ }
                                                                {/*    )*/ }
                                                                {/*}*/ }
                                                            </div>
                                                        ) }
                                                    </div>
                                                ) ) }
                                        { categoryIndex < businessSkills.length - 1 && (
                                            <hr className="m-0 mt-1"
                                                style={ { color: isEuropass ? "#000000" : "#09B4BF" } }
                                            />
                                        ) }
                                    </div>
                                </div>
                            </React.Fragment>
                        ) ) }
                </div>
            </div>
        </>
    );
}
